// TODO: Add image alt tag.
/* eslint-disable jsx-a11y/alt-text */
import { PageComponent } from '@root/pages/Type';
import { ReactNode } from 'react';
import styles from './OsSection.module.scss';

type OsSectionProps = {
    title: ReactNode;
    description: ReactNode;
    logos: string[];
    osNumber: string;
};

type OsSectionImageProps = {
    logo: string;
}

const OsSectionImage: PageComponent<OsSectionImageProps> = ({ logo }) => {
    return (
        <div className={styles.os_inner}>
            <div>
                <img src={`/static/img/icons/os/${logo}.svg`} />
            </div>
        </div>
    )
}

const OsSection: PageComponent<OsSectionProps> = ({ title, description, logos, osNumber }) => {
    return (
        <section className={styles.section}>
            <div className={`${styles.container_text} container`}>
                <h1 className={styles.title}>{title}</h1>
                <p className={styles.desc}>{description}</p>
            </div>
            <div className={styles.os_content}>
                <div className={styles.os_containt}>
                    <div className={styles.os_container}>
                        {logos.map(logo => <OsSectionImage key={logo} logo={logo} />)}
                    </div>
                </div>
                <div className={styles.os_number}>
                    <img src={`/static/img/${osNumber}.svg`} />
                </div>
            </div>
        </section>
    );
};

export default OsSection;
